import { Discount, EmployeeDiscount, InfoDiscount, VoucherDiscount } from "@/types/discount";

export const isEmployeeDiscount = (discount: Discount): discount is EmployeeDiscount => {
  return discount.type === "employee_discount";
};

export const isVoucherDiscount = (discount: Discount): discount is VoucherDiscount => {
  return discount.type === "discount";
};

export const isInfoDiscount = (discount: Discount): discount is InfoDiscount => {
  return discount.type === "info";
};

export const getDiscountId = (discount: Discount) => {
  if (isEmployeeDiscount(discount)) return discount.meta.employeeDiscount.employeeId;
  if (isVoucherDiscount(discount)) return discount.meta.voucher.extId;
  if (!discount.meta) return;
  return "voucher" in discount.meta ? discount.meta.voucher.extId : undefined;
};
